/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useMemo, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// 复用“学生作品”里原来渲染的内容（如果里面就是学生作品视频/组件）
import CeremonyContent from "../elements/ceremony-content";

// 顶部 Tab 按钮（样式模仿你的图片页）
const FilterTab = ({ label, isActive, onClick }) => (
  <li className={`btn ${isActive ? "active" : ""}`} onClick={onClick}>
    <Link to="#">{label}</Link>
  </li>
);

// 响应式 16:9 视频卡片
const VideoCard = ({ youtubeId, caption }) => (
  <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
      }}
    >
      <iframe
        src={`https://www.youtube.com/embed/${youtubeId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        title={youtubeId}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }}
      />
    </div>
    {caption && (
      <div className="mt-2" style={{ minHeight: 48 }}>
        <h6 style={{ fontWeight: 500, lineHeight: 1.4 }}>{caption}</h6>
      </div>
    )}
  </div>
);

// 用稳定的 key 做选中状态，避免语言切换后字符串变更导致状态丢失
const TABS = {
  award: "award",
  student: "student",
};

const VideosContentInner = () => {
  const { t } = useTranslation();

  // Tab 文案（每次渲染用 t() 获取，保证切换语言后立即更新）
  const labelAward = t("Achievements_Videos_Award_Ceremony"); // 颁奖典礼
  const labelStudent = t("Achievements_Videos_Student_Work"); // 学生作品

  // 选中 Tab：使用稳定 key
  const [selectedTab, setSelectedTab] = useState(TABS.award);

  // 你的“无分页视频页面”里的所有视频，改为数组映射渲染
  const awardVideos = useMemo(
    () => [
      { id: "FG_DyRS7Ogw", caption: t("Videos_Description_Video0") },
      { id: "bUDYF0nT_4g", caption: t("Videos_Description_Video1") },
      { id: "rko3lOWh6rY", caption: t("Videos_Description_Video2") },
      { id: "IzucDoTH-Ec", caption: t("Videos_Description_Video3") },
      { id: "I-_X2t2hMEw", caption: t("Videos_Description_Video4") },
      { id: "vE84mCxdvqk", caption: t("Videos_Description_Video5") },
      { id: "Oi1pMKO-cwM", caption: t("Videos_Description_Video6") },
      { id: "iOP3SXDnwwo", caption: t("Videos_Description_Video7") },
      { id: "xxf4K1X_838", caption: t("Videos_Description_Video8") },
      { id: "DFdn1u8SHXs", caption: t("Videos_Description_Video9") },
      { id: "fNoRQlWcHoY", caption: t("Videos_Description_Video10") },
      { id: "0FnpkEHsf2Q", caption: t("Videos_Description_Video11") },
      { id: "ho3N9rkMz64", caption: t("Videos_Description_Video12") },
      { id: "h-2EYS4m66U", caption: t("Videos_Description_Video13") },
      { id: "sdGNZ1GbyMY", caption: t("Videos_Description_Video14") },
      { id: "EdpWmtI6Jew", caption: t("Videos_Description_Video15") },
      { id: "X3aqXsFcDu0", caption: t("Videos_Description_Video16") },
    ],
    [t]
  );

  return (
    <>
      {/* 顶部 Tabs（风格与 Achievements 图片页一致） */}
      <div className="feature-filters clearfix center m-b40">
        <ul className="filters" data-toggle="buttons">
          <FilterTab
            label={labelAward}
            isActive={selectedTab === TABS.award}
            onClick={() => setSelectedTab(TABS.award)}
          />
          <FilterTab
            label={labelStudent}
            isActive={selectedTab === TABS.student}
            onClick={() => setSelectedTab(TABS.student)}
          />
        </ul>
      </div>

      {/* 内容：颁奖典礼 */}
      {selectedTab === TABS.award && (
        <div className="row">
          {awardVideos.map((v, idx) => (
            <VideoCard key={v.id + idx} youtubeId={v.id} caption={v.caption} />
          ))}
        </div>
      )}

      {/* 内容：学生作品（复用原组件） */}
      {selectedTab === TABS.student && (
        <div className="row">
          <div className="col-12">
            <CeremonyContent />
          </div>
        </div>
      )}
    </>
  );
};

// 保持与项目一致的导出方式
function VideosContent() {
  return <VideosContentInner />;
}

export default withTranslation()(VideosContent);
